import React from 'react';
import ArrowLeftIcon from '@heroicons/react/outline/ArrowLeftIcon.js';
import ChevronRightIcon from '@heroicons/react/outline/ChevronRightIcon.js';
import DocumentTextIcon from '@heroicons/react/outline/DocumentTextIcon.js';
import { PostListFilterByEnum, PostListFilterByOperator, } from '@tribeplatform/gql-client/types';
import { EntityImage } from '@tribeplatform/react-components/common';
import { T } from '@tribeplatform/react-components/i18n';
import { useRouter } from '@tribeplatform/react-sdk';
import { useAuthToken, usePosts } from '@tribeplatform/react-sdk/hooks';
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Card } from '@tribeplatform/react-ui-kit/Card';
import { List } from '@tribeplatform/react-ui-kit/Layout';
export const Drafts = ({ postTypeId }) => {
    const { data: { member, network }, } = useAuthToken();
    const { Link, push, location } = useRouter();
    const getPostTypeIcon = (post) => {
        var _a;
        const postType = (_a = network === null || network === void 0 ? void 0 : network.postTypes) === null || _a === void 0 ? void 0 : _a.find(postType => postType.id === (post === null || post === void 0 ? void 0 : post.postTypeId));
        return postType === null || postType === void 0 ? void 0 : postType.icon;
    };
    const { data } = usePosts({
        variables: {
            postTypeIds: postTypeId ? [postTypeId] : undefined,
            limit: 50,
            filterBy: [
                {
                    keyString: 'status',
                    key: PostListFilterByEnum.publishedAt,
                    operator: PostListFilterByOperator.equals,
                    value: JSON.stringify('DRAFTED'),
                },
                {
                    keyString: 'createdById',
                    key: PostListFilterByEnum.publishedAt,
                    operator: PostListFilterByOperator.equals,
                    value: JSON.stringify(member === null || member === void 0 ? void 0 : member.id),
                },
            ],
        },
        fields: 'basic',
    });
    const drafts = simplifyPaginatedResult(data);
    return (React.createElement(Card, { className: "w-full" },
        React.createElement(Card.Header, { title: React.createElement("div", { className: "flex space-s-3 items-center" },
                React.createElement(Button, { variant: "basic", rounded: true, size: "lg", leadingIcon: React.createElement(ArrowLeftIcon, { className: "rtl:-scale-x-100" }), onClick: () => {
                        var _a;
                        if (location === null || location === void 0 ? void 0 : location.key) {
                            (_a = window === null || window === void 0 ? void 0 : window.history) === null || _a === void 0 ? void 0 : _a.back();
                        }
                        else {
                            push('/');
                        }
                    } }),
                React.createElement("span", { className: "text-xl flex-1" },
                    React.createElement(T, { id: "Generics.YourDrafts", defaultMessage: "Your drafts" }))) }),
        React.createElement(Card.Content, null,
            React.createElement(List, { divider: true, spacing: "none", className: "border-t border-line-subdued" }, drafts.nodes.map(draft => {
                const postTypeIcon = getPostTypeIcon(draft);
                return (React.createElement(List.Item, { key: draft.id },
                    React.createElement(Link, { variant: "inherit", className: "hover:bg-surface-hovered px-4 py-5 sm:p-6 flex space-s-3 items-center", href: `${draft === null || draft === void 0 ? void 0 : draft.relativeUrl}/edit` },
                        postTypeIcon ? (React.createElement(EntityImage, { size: "xs", entity: { image: postTypeIcon, name: draft === null || draft === void 0 ? void 0 : draft.title } })) : (React.createElement(DocumentTextIcon, { className: "w-6 h-6" })),
                        React.createElement("h4", { className: "flex-1" }, draft === null || draft === void 0 ? void 0 : draft.title),
                        React.createElement(ChevronRightIcon, { className: "w-6 h-6 rtl:-scale-x-100" }))));
            })))));
};
//# sourceMappingURL=Drafts.js.map